import React, { Component } from 'react';
//import './App.css';
import '@fortawesome/fontawesome-free/css/all.css';
import { createHashHistory } from 'history';
import { HashRouter, Route } from 'react-router-dom';
import central from './api/Central';
import ScrollToTop from './components/ScrollToTop.js';
import Acessos from './pages/Acessos';
import Boletos from './pages/Boletos.js';
import ChamadoNovo from './pages/ChamadoNovo.js';
import Chamados from './pages/Chamados.js';
import DetalheBoleto from './pages/DetalheBoleto.js';
import Home from './pages/Home.js';
import Login from './pages/Login.js';
import Notas from './pages/Notas';
import Religar from './pages/Religar';
import ReligarDetalhe from './pages/ReligarDetalhe.js';

const history = createHashHistory();


class App extends Component {

  urlPreLogin = null;

  constructor(props) {
    super(props);
    this.state = {
      whoami: { autenticado: false },
      kit: {}
    };

  }

  componentDidMount() {
    central.onPrecisaLogar = () => {
      this.setState({
        whoami: { autenticado: false }
      });
      var urlAtual = window.location.hash.replace(/^#/, "");

      if (urlAtual !== "/login") {
        this.urlPreLogin = urlAtual;
        history.push("/login")
      }
    };
    central.onLogin = (whoami) => {
      this.setState({
        whoami: whoami
      });
      if (this.urlPreLogin !== null) {
        history.push(this.urlPreLogin);
      } else {
        history.push("/");
      }
    }
    central.onLogout = () => {
      this.setState({
        whoami: { autenticado: false }
      });
    }

    central.request("GET", "/whoami", null, (payload) => {
      this.setState({ whoami: payload });
    });

    central.fetchKit(
      () => {
        this.setState({ kit: central.kit });
      });
  }

  render() {

    var customHome = <Home kit={this.state.kit} whoami={this.state.whoami} />;

    return (
      <React.Fragment>
        <HashRouter on>
          <ScrollToTop>
            <div>
              <main>

                <Route exact path="/" children={({ match }) => {
                  return (<React.Fragment>{match && customHome}</React.Fragment>)
                }
                }></Route>
                <Route exact path="/boletos" component={Boletos} />
                <Route exact path="/boletos/:id" component={DetalheBoleto} />
                <Route exact path="/religar" component={Religar} />
                <Route exact path="/religar/:id" component={ReligarDetalhe} />
                <Route exact path="/chamados" component={Chamados} />
                <Route exact path="/chamados/novo" component={ChamadoNovo} />
                <Route exact path="/login" component={Login} />
                <Route exact path="/acessos" component={Acessos} />
                <Route exact path="/notas" component={Notas} />
              </main>
              <footer>
                <div className="container">
                  {this.state.kit.avisoRodape && <div dangerouslySetInnerHTML={{ __html: this.state.kit.avisoRodape }} />}
                </div>
              </footer>
            </div>
          </ScrollToTop>
        </HashRouter>
      </React.Fragment>
    );
  }
}

export default App;
